// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2qPMk","error":"Textarea_error__203Cw","readonly":"Textarea_readonly__Ev49G","disabled":"Textarea_disabled__MwIJf"};